
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/leiebil",
      function () {
        return require("private-next-pages/leiebil.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/leiebil"])
      });
    }
  